import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-error-book',
  templateUrl: './error-book.component.html',
  styleUrls: ['./error-book.component.scss']
})
export class ErrorBookComponent  {

  constructor(
    public dialogRef: MatDialogRef<ErrorBookComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string) { }


  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }
}
